export const SAVE_STATE_SETTINGS = 'stateSettings/SAVE_STATE_SETTINGS'
export const SAVE_STATE_SETTINGS_SUCCESS = 'stateSettings/SAVE_STATE_SETTINGS_SUCCESS'
export const SAVE_STATE_SETTINGS_ERROR = 'stateSettings/SAVE_STATE_SETTINGS_ERROR'

export const saveSettingsBlackList = [SAVE_STATE_SETTINGS, SAVE_STATE_SETTINGS_ERROR]
